import React from "react";

function FlowEmpty({ icon, title, message, children }) {
  return (
    <div className="hm-fempty">
      <span className="hm-fempty-ico" aria-hidden="true">
        <i className={icon}></i>
      </span>
      <h3>{title}</h3>
      <p>{message}</p>
      {children && <div className="hm-fempty-actions">{children}</div>}
    </div>
  );
}

export default FlowEmpty;
